import ApiClient from '../client';
import { ErrorService } from '@/services/error-service.js';
const path = require('path');

class IndexerAPI extends ApiClient {

  constructor() {
    super();
  }

  async getIndexers() {
    const route = path.join(
      this.INDEXER_API_PATH,
      'remote-api-indexes/'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async getUsergroupIndexers(usergroupId) {
    const route = path.join(
      this.INDEXER_API_PATH,
      `remote-api-indexes/?usergroup_id=${usergroupId}`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async getIndexersTypes() {
    const route = path.join(
      this.INDEXER_API_PATH,
      'remote-api-index-types/'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async getIndexer(id) {
    const route = path.join(
      this.INDEXER_API_PATH,
      `remote-api-indexes/${id}`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async testIndexer(id) {
    const route = path.join(
      this.INDEXER_API_PATH,
      `remote-api-indexes/${id}/trial/`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async createIndexer(data) {
    try {
      const route = path.join(
        this.INDEXER_API_PATH,
        'remote-api-indexes/'
      );
      const response = await this.post(route, data);
      if (response.status === 201) {
        ErrorService.onSuccess(
          response,
          i18n.messages[i18n.locale].indexers.messages.created.success
        );
        return response.data;
      }
    } catch {
      ErrorService.onError(
        false,
        i18n.messages[i18n.locale].indexers.messages.created.error
      );
      return false;
    }
  }

  async updateIndexer(id, data) {
    try {
      const route = path.join(
        this.INDEXER_API_PATH,
        `remote-api-indexes/${id}/`
      );
      const response = await this.put(route, data);
      if (response.status === 200) {
        ErrorService.onSuccess(
          response,
          i18n.messages[i18n.locale].indexers.messages.updated.success
        );
        return response.data;
      }
    } catch {
      ErrorService.onError(
        false,
        i18n.messages[i18n.locale].indexers.messages.updated.error
      );
      return false;
    }
  }

  async deleteIndexer(id) {
    try {
      const route = path.join(
        this.INDEXER_API_PATH,
        `remote-api-indexes/${id}/`
      );
      const response = await this.delete(route);
      if (response.status === 204) {
        ErrorService.onSuccess(
          response,
          i18n.messages[i18n.locale].indexers.messages.deleted.success
        );
        return true;
      }
    } catch {
      ErrorService.onError(
        false,
        i18n.messages[i18n.locale].indexers.messages.deleted.error
      );
      return false;
    }
  }
};

const  indexerAPI = new IndexerAPI();
export default indexerAPI;